import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DURATION, EASE } from "./animation-config.js";

gsap.registerPlugin(ScrollTrigger);
const SLIDE_X_LEFT = "-100vw";
const SLIDE_X_RIGHT = "100vw";
const MEDIA_Y = "18vh";

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

function getSlideTargets(section, side) {
  const person = section.querySelector(`.about-section__person--${side}`);

  if (!person) {
    return [];
  }

  return [
    ...person.querySelectorAll(".about-section__pos, .about-section__text"),
  ];
}

function setInitialState(leftTargets, rightTargets, media) {
  leftTargets.forEach((element) => {
    gsap.set(element, { x: SLIDE_X_LEFT, opacity: 0 });
  });

  rightTargets.forEach((element) => {
    gsap.set(element, { x: SLIDE_X_RIGHT, opacity: 0 });
  });

  if (media) {
    gsap.set(media, { y: MEDIA_Y });
  }
}

function initAboutSection(section) {
  const leftTargets = getSlideTargets(section, "left");
  const rightTargets = getSlideTargets(section, "right");
  const media = section.querySelector(".about-section__media");

  if (!leftTargets.length && !rightTargets.length && !media) {
    return;
  }

  if (reducedMotion) {
    gsap.set([...leftTargets, ...rightTargets], { x: 0, opacity: 1 });

    if (media) {
      gsap.set(media, { y: 0 });
    }

    section.classList.add("is-in-view");
    return;
  }

  setInitialState(leftTargets, rightTargets, media);

  ScrollTrigger.create({
    trigger: section,
    start: "top 70%",
    once: true,
    onEnter: () => {
      section.classList.add("is-in-view");

      const timeline = gsap.timeline({
        defaults: { duration: DURATION, ease: EASE },
      });

      if (leftTargets.length) {
        timeline.to(leftTargets, { x: 0, opacity: 1 }, 0);
      }

      if (rightTargets.length) {
        timeline.to(rightTargets, { x: 0, opacity: 1 }, 0);
      }

      if (media) {
        timeline.to(media, { y: 0 }, 0);
      }
    },
  });
}

document.querySelectorAll(".about-section").forEach(initAboutSection);

window.addEventListener(
  "load",
  () => {
    ScrollTrigger.refresh();
  },
  { once: true },
);
